import { Injectable } from '@angular/core';
import {
    FormInitialisationParameter,
    LookupFieldResult,
} from '@wdx/shared/utils';

@Injectable({ providedIn: 'root' })
export class FormInitialisationParametersService {
    createFormFieldInitialisationParams(
        initialisationParameters: FormInitialisationParameter[],
        formData: Record<string, any>,
    ): Record<string, any> {
        const params: Record<string, string> = {};
        initialisationParameters?.forEach((param) => {
            const { field, parameter, entityTypes } = param;
            if (
                !field ||
                !parameter ||
                !Object.hasOwn(formData, field) ||
                formData[field]?.length === 0
            ) {
                return;
            }
            const value = formData[field];
            if (Array.isArray(value)) {
                const match = (value as LookupFieldResult[])?.find((entry) =>
                    entityTypes?.some((type) => entry.lookupType === type),
                );
                if (match?.id) {
                    params[parameter] = match.id;
                }
            } else if (value?.id) {
                params[parameter] = value.id;
            } else if (value) {
                params[parameter] = value;
            }
        });

        return params;
    }
}
